
if(!customElements.get('ss-product-models')){
 customElements.define('ss-product-models',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();
   const signal=this.controller.signal;
   this.tabs=Array.from(this.querySelectorAll('[role="tab"]'));
   this.expand=this.querySelector('[data-ss-expand]');
   this.addEventListener('click',event=>{
    const tab=event.target.closest('[role="tab"]');
    if(tab&&this.contains(tab))this.select(tab);
    if(event.target.closest('[data-ss-expand]'))this.toggleExpanded();
    const start=event.target.closest('[data-ss-activate]');if(start)this.activate(start.closest('[role=tabpanel]'));
   },{signal});
   this.addEventListener('keydown',event=>{
    const tab=event.target.closest('[role="tab"]');
    if(tab&&['ArrowRight','ArrowLeft','Home','End'].includes(event.key)){
     event.preventDefault();
     const current=this.tabs.indexOf(tab);
     const index=event.key==='Home'?0:event.key==='End'?this.tabs.length-1:(current+(event.key==='ArrowRight'?1:-1)+this.tabs.length)%this.tabs.length;
     this.select(this.tabs[index]);this.tabs[index].focus();
    }
    if(event.key==='Escape'&&this.classList.contains('is-expanded'))this.closeExpanded();
   },{signal});
   document.addEventListener('fullscreenchange',()=>this.updateExpanded(),{signal});
  }
  disconnectedCallback(){this.closeExpanded();this.controller?.abort();this.controller=null;}
  select(tab){
   this.tabs.forEach(item=>{
    const active=item===tab;
    item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;
    const panel=this.querySelector('#'+CSS.escape(item.getAttribute('aria-controls')));
    panel.hidden=!active;
    
   });
  }
  activate(panel){
   const template=panel.querySelector('template[data-ss-model-template]');
   if(!template)return;
   const fragment=template.content.cloneNode(true);
   const model=fragment.querySelector('model-viewer');
   const interiorFrame=fragment.querySelector('iframe[data-ss-interior-frame]');
   const poster=panel.querySelector('[data-ss-activate]');
   const label=poster.querySelector('span');
   const initialLabel=label.textContent;
   label.textContent=poster.dataset.loadingLabel;
   const error=panel.querySelector('[data-ss-error]');
   let ready=false;
   const failure=()=>{if(!ready){label.textContent=this.dataset.previewLabel;poster.disabled=true;error.hidden=false;}};
   if(model){
    model.setAttribute('reveal','auto');
    model.addEventListener('load',()=>{ready=true;poster.hidden=true;error.hidden=true;},{once:true});
    model.addEventListener('error',failure,{once:true});
   }
   if(interiorFrame){
    window.addEventListener('message',event=>{
     if(event.source!==interiorFrame.contentWindow)return;
     if(event.data?.type==='ss-interior-ready'){ready=true;poster.hidden=true;error.hidden=true;}
     if(event.data?.type==='ss-interior-error')failure();
    },{signal:this.controller.signal});
   }
   template.replaceWith(fragment);
   setTimeout(failure,30000);
  }
  async toggleExpanded(){
   if(document.fullscreenElement===this){await document.exitFullscreen();return;}
   if(this.classList.contains('is-expanded')){this.closeExpanded();return;}
   if(this.requestFullscreen){try{await this.requestFullscreen();return;}catch{}}
   this.savedOverflow=document.documentElement.style.overflow;
   document.documentElement.style.overflow='hidden';this.classList.add('is-expanded');this.updateExpanded();
  }
  closeExpanded(){
   if(this.classList.contains('is-expanded')){this.classList.remove('is-expanded');document.documentElement.style.overflow=this.savedOverflow||'';}
   this.updateExpanded();
  }
  updateExpanded(){
   if(!this.expand)return;
   const active=document.fullscreenElement===this||this.classList.contains('is-expanded');
   this.expand.textContent=active?this.dataset.closeLabel:this.dataset.expandLabel;
   this.expand.setAttribute('aria-expanded',String(active));
  }
 });
}

